// React&NextJS
import React, {
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
} from 'react'
import Head from 'next/head'
// 3rd party libraries
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
// Styles
import s from './Gallery.module.scss'
import classnames from 'classnames'
// Components
import { Image } from '../../core/image/Image'
import { CloseButton } from '../closeButton/CloseButton'
import { UIContext } from '../../../context/UIContext'

const c = classnames.bind(s)

type Props = {
    gallery: Array<string>
    index: number
    showModal: Boolean
    setShowModal: Function
}

export default function Gallery({
    gallery,
    index,
    showModal,
    setShowModal,
}: Props) {
    const { uiState, setUIState } = useContext(UIContext)
    const [galleryCpy, setGalleryCpy] = useState([])
    const [visible, setVisible] = useState(false)

    const modalRef = useRef()
    //Function to close modal when user press escape button
    const keyPress = useCallback(
        (e) => {
            // document.getElementById(`openImage${index}`).click()
            if (e.key === 'Escape' && showModal) {
                closeModal(e, true)
            }
        },
        [setShowModal, showModal]
    )
    const closeModal = (e: React.SyntheticEvent, close = false) => {
        if (modalRef.current === e.target || close) {
            setShowModal(false)
            setUIState({ ...uiState, canScroll: true })
        }
    }
    useEffect(() => {
        const g = [...gallery]
        if (g.length === 1) {
            g.push(
                'https://upload.wikimedia.org/wikipedia/commons/8/89/HD_transparent_picture.png'
            )
        }
        setGalleryCpy(g)
    }, [])

    useEffect(() => {
        const timeout = gallery.length > 10 ? 1000 : 400
        setTimeout(() => {
            setVisible(true)
        }, timeout)
    }, [])

    //Used to call keyPress function by adding a listener
    //Removes the listener after keyPress
    //Runs each time user clicks or presses a key
    useEffect(() => {
        // document.getElementById(`openImage${index}`).click()
        document.addEventListener('keydown', keyPress)
        return () => document.removeEventListener('keydown', keyPress)
    }, [keyPress])

    const settings = {
        className: c('variable-width', 'slick-frame', s.slider),
        initialSlide: index,
        dots: false,
        infinite: false,
        draggable: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        centerPadding: '0',
        centerMode: true,
        variableWidth: true,
        accessibility: gallery.length === 1 ? false : true,
        focusOnSelect: gallery.length === 1 ? false : true,
        swipe: gallery.length === 1 ? false : true,
        //Touch displays
        swipeToSlide: gallery.length === 1 ? false : true,
    }

    return (
        <>
            <Head>
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                />
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
                />
            </Head>
            <div className={s.background} onClick={closeModal} ref={modalRef}>
                {/* Close button */}
                <div className={s.button} onClick={(e) => closeModal(e, true)}>
                    <CloseButton open={false} />
                </div>
                {/* Slider */}
                <div
                    className={s.gallery}
                    style={
                        visible
                            ? { visibility: 'visible' }
                            : { visibility: 'hidden' }
                    }
                >
                    <Slider {...settings}>
                        {galleryCpy.map((image: string, i: number) => {
                            return (
                                <div key={i}>
                                    <Image
                                        id={`openImage${i}`}
                                        src={image}
                                        lazy
                                        height={800}
                                        alt=""
                                        style={{
                                            imageRendering:
                                                '-webkit-optimize-contrast',
                                        }}
                                    />
                                </div>
                            )
                        })}
                    </Slider>
                </div>
            </div>
        </>
    )
}
